import { QueryKey } from '@tanstack/react-query';
import { UserService } from '../../api';
import { DefaultQueryKeyFactory, QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const userQueryKeys = new QueryKeyFactoryGenerator<
  DefaultQueryKeyFactory,
  { notifications: () => QueryKey }
>('user', { notifications: () => ['user', 'allLists', 'notifications'] }).getDefault<
  typeof UserService.userList
>();
